import { PaymentStatusEnum } from '../constants';

export const getPaymentStatusText = (status: string) => {
  switch (status) {
    case PaymentStatusEnum.SENT:
      return 'Sent';
    case PaymentStatusEnum.CONFIRMED:
      return 'Confirmed';
    case PaymentStatusEnum.PAID:
      return 'Paid';
    case PaymentStatusEnum.CANCELLED:
      return 'Cancelled';
    case PaymentStatusEnum.FAILED:
      return 'Failed';
    default:
      return '<N/A>';
  }
};

export const getPaymentStatusStyle = (status: string) => {
  switch (status) {
    case PaymentStatusEnum.SENT:
      return {
        backgroundClass: 'status-approved-bg',
        textClass: 'status-approved-text',
      };
    case PaymentStatusEnum.CONFIRMED:
      return {
        backgroundClass: 'status-approved-bg',
        textClass: 'status-approved-text',
      };
    case PaymentStatusEnum.PAID:
      return {
        backgroundClass: 'status-approved-bg',
        textClass: 'status-approved-text',
      };
    case PaymentStatusEnum.CANCELLED:
      return {
        backgroundClass: 'status-cancelled-bg',
        textClass: 'status-cancelled-text',
      };
    case PaymentStatusEnum.FAILED:
      return {
        backgroundClass: 'status-cancelled-bg',
        textClass: 'status-cancelled-text',
      };
    default:
      return {
        backgroundClass: 'status-default-bg',
        textClass: 'status-default-text',
      };
  }
};
